import setDealDetails from './actions/setDealDetails';
import updateDealDetails from './actions/updateDealDetails';
import updateDealNotifications from './actions/updateDealNotifications';
import updateDealReminders from './actions/updateDealReminders';
import resetDealNotifications from './actions/resetDealNotifications';
import addHideReceiptListing from './actions/addHideReceiptListing';
import removeHideReceiptListing from './actions/removeHideReceiptListing';
import updateCreditAppDeals from './actions/updateCreditAppDeals';
export default duck => ({
  setDealDetails: setDealDetails(duck),
  updateDealDetails: updateDealDetails(duck),
  updateDealNotifications: updateDealNotifications(duck),
  updateDealReminders: updateDealReminders(duck),
  resetDealNotifications: resetDealNotifications(duck),
  addHideReceiptListing: addHideReceiptListing(duck),
  removeHideReceiptListing: removeHideReceiptListing(duck),
  updateCreditAppDeals: updateCreditAppDeals(duck)
});